import { render } from "./TechnicalRequirements.vue?vue&type=template&id=73d8d6b7"
import script from "./TechnicalRequirements.vue?vue&type=script&lang=js"
export * from "./TechnicalRequirements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__